export const Logo = ({ dark = false, testId = "logo" }) => (
  <span data-testid={testId} className="flex select-none items-baseline gap-[3px] leading-none">
    <span
      className={`text-[25px] font-extrabold tracking-[-0.04em] ${
        dark ? "text-white" : "text-slate-900"
      }`}
    >
      Juris
    </span>
    <span className="h-[7px] w-[7px] translate-y-[-2px] rounded-[2px] bg-blue-600" aria-hidden="true" />
  </span>
);

export default Logo;